<template>
  <div :style="getElementStyle">

    <div v-if="!isDefalutPos">
      <div style="display: flex; align-items: unset;">
        <icons v-if="isIconRequired" :iconName="data.icon_name" class="mr-1"></icons>
        <label for="text" style="white-space: nowrap; margin-right: 5px;">{{ data.label }}</label>
        <span
          v-if="data.validations.required"
          style="color: red; font-weight: bold; margin-right: 10px;"
        >
          *
        </span>
        <span> <i
        class="el-icon-copy-document " v-if="!isDataTableField" @click="copyDocument" ></i></span>
        <span>
          <el-popover
          v-if="data.description"
          title="Help"
          placement="too-start"
          trigger="click"
          :content="data.description"
        >
          <i
            class="el-icon-info"
            :title="data.description"
          ></i>
        </el-popover>
        </span>
        <span>
          <el-row
        v-if="isActive || isDataTableField"
        class="setting-icon"
      >
        <i
          class="el-icon-s-tools"
          @click="openSettings"
        ></i>
      </el-row>
        </span>
        <span>
          <el-radio-group
          :style="getStyle"
          :model="selectedValue"
        >
          <el-radio label="YES">YES</el-radio>
          <el-radio label="NO">NO</el-radio>
        </el-radio-group>
        </span>
      </div>
    </div>

    <el-row align="middle" v-else>
      <el-col v-if="!isInDataTable" :span="showLabel && !isDefalutPos ? 4 : data.description ? 20 : 24" class="bottom-space">
      <span style="display: flex;">
        <icons v-if="isIconRequired" :iconName="data.icon_name" class="mr-1"></icons>
        <label for="text">{{ data.label }}</label>
        <span
          v-if="data.validations.required"
          style="color: red; font-weight: bold"
        >
          *
        </span>
        <i
        class="el-icon-copy-document " v-if="!isDataTableField" @click="copyDocument" ></i>
        </span>
        <span>
          <el-popover
            v-if="data.description"
            placement="top-start"
            trigger="hover"
            :content="data.description"
          >
            <i class="el-icon-info" slot="reference"></i>
          </el-popover>
        </span>
      </el-col>
      <el-col :span="showLabel && isDefalutPos ? 4 : 0">
        <el-popover
          v-if="data.description"
          title="Help"
          placement="too-start"
          trigger="click"
          :content="data.description"
        >
          <i
            class="el-icon-info"
            :title="data.description"
          ></i>
        </el-popover>
      </el-col>
      <el-row
        v-if="isActive || isDataTableField"
        class="setting-icon"
      >
        <i
          class="el-icon-s-tools"
          @click="openSettings"
        ></i>
      </el-row>
      <el-col :span="showLabel
        &&
        !isDefalutPos
        ?
        12
        :
        24">
        <el-radio-group
          :style="getStyle"
          :model="selectedValue"
        >
          <el-radio label="YES">YES</el-radio>
          <el-radio label="NO">NO</el-radio>
        </el-radio-group>
      </el-col>
    </el-row>
    <!--<div>
      {{data.label}}
      <span v-if="data.description">
        <i class="el-icon-info" :title="data.description" />
      </span>
      <span v-if="isActive || isDataTableField" class="setting-icon" @click="openSettings">
        <i class="el-icon-s-tools" />
      </span>
    </div>
    <el-radio-group :style="getStyle" :model="selectedValue">
      <el-radio label="YES">YES</el-radio>
      <el-radio label="NO">NO</el-radio>
    </el-radio-group>-->
  </div>
</template>

<script>
import templateBuilderHelper from "@/mixins/templateBuilderHelper";

export default {
  name: "YesOrNoView",
  components: {},
  props: ["data", "value", "isActive", "isDataTableField","isInDataTable","isIconRequired"],
  mixins: [templateBuilderHelper],
  computed: {
    selectedValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    getStyle() {
      return `height:${this.data.height - 30}px`;
    },
    getElementStyle() {
      let borderStyle = "";
      if (this.data.styles) {
        let type = this.data.styles.border_type
          ? this.data.styles.border_type
          : "solid";
        let size = this.data.styles.border_size
          ? this.data.styles.border_size + "px"
          : "0px";
        let color = this.data.styles.border_color
          ? this.data.styles.border_color
          : "";
        let font_size =
          this.data.styles &&
          this.data.styles.font &&
          this.data.styles.font.font_size
            ? this.data.styles.font.font_size
            : "";
        let bold =
          this.data.styles &&
          this.data.styles.font &&
          (this.data.styles.font.style == 1 || this.data.styles.font.style == 3)
            ? "bold"
            : "";
        let italic =
          this.data.styles &&
          this.data.styles.font &&
          (this.data.styles.font.style == 2 || this.data.styles.font.style == 3)
            ? "italic"
            : "";
        borderStyle = "border:" + type + " " + " " + size + " " + color;

        borderStyle += ";";
        borderStyle += this.data.styles.background
          ? `background: ${this.data.styles.background}`
          : "";
        borderStyle += ";";
        borderStyle += this.data.styles.label_color
          ? `color: ${this.data.styles.label_color}`
          : "";
        borderStyle += ";";
        borderStyle += "font-size:" + font_size + "px;";
        if (bold) {
          borderStyle += "font-weight:" + bold + ";";
        }
        if (italic) {
          borderStyle += "font-style:" + italic + ";";
        }
        borderStyle += this.data.styles.label_color
          ? `color: ${this.data.styles.label_color}`
          : "";
      }
      return borderStyle;
    },
    //gayatri starts
    isDefalutPos() {
      if (this.data.styles && this.data.styles.labelStyle == "right") {
        return false;
      } else {
        return true;
      }

      // return isDefalutPosq;
    }
    //ends
  },
  mounted() {
    if (this.data.styles && this.data.styles.labelStyle) {
      if (this.data.styles.labelStyle == "hide") {
        this.showLabel = false;
      }
      if (this.data.styles.labelStyle == "right") {
        this.isDefalutPosq = false;
      }
    }
  },
  data() {
    return {
      validations: [],
      showLabel: true,
      isDefalutPosq: true
    };
  },
  methods: {
    copyDocument() {
    this.$emit("copy-document", this.data.key);
  },
    openSettings() {
      this.$emit("settings");
    }
  },
  watch: {
    isActive: {
      immediate: true,
      handler() {
      }
    }
  }
};
</script>

<style lang="scss">
.el-popover--plain {
    padding: 5px 10px;
}
.el-popover { 
    min-width: 40px;
}
</style>